import React from 'react';
interface Tab {
  id: string;
  label: string;
}
interface TabViewProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (tabId: string) => void;
  selectedYear?: number;
  onYearChange?: (year: number) => void;
}
export const TabView: React.FC<TabViewProps> = ({
  tabs,
  activeTab,
  onChange,
  selectedYear = 2023,
  onYearChange = () => {}
}) => {
  return <div className="flex items-center space-x-3" data-id="element-200">
      <div className="relative" data-id="element-201">
        <select value={selectedYear} onChange={e => onYearChange(Number(e.target.value))} className="appearance-none bg-white border border-gray-200 rounded-md py-2 pl-4 pr-8 text-gray-800 font-medium focus:outline-none focus:ring-1 focus:ring-gray-200" data-id="element-202">
          {[2023, 2022, 2021, 2020, 2019].map(year => <option key={year} value={year} data-id="element-203">
              {year}
            </option>)}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700" data-id="element-204">
          <svg className="w-4 h-4 fill-current" viewBox="0 0 20 20" data-id="element-205">
            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" data-id="element-206" />
          </svg>
        </div>
      </div>
      <div className="flex space-x-1 bg-gray-200 p-1 rounded-lg" data-id="element-207">
        {tabs.map(tab => <button key={tab.id} className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${activeTab === tab.id ? 'bg-white text-gray-800 shadow' : 'text-gray-600 hover:text-gray-800 hover:bg-gray-100'}`} onClick={() => onChange(tab.id)} data-id="element-208">
            {tab.id === 'data' ? 'Detailed Records' : tab.label}
          </button>)}
      </div>
    </div>;
};